import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import numbro from 'numbro';

import 'swiper/css/pagination';

import { CurrencyType, StaminaType } from '../../../../constants/currencies';
import { SVGIconType } from '../../../../constants/svgIcon';
import { getWebBoosterVairant } from '../../../../constants/webBoosterType';
import { BalanceType } from '../../../../models/Base';
import {
  getQuickCreateGameModeVersion,
  QuickCreateGameMode,
} from '../../../../models/DraftStore';
import { Profile, WebBoosterType } from '../../../../models/UserStore';
import {
  AvatarNode,
  CreateMemoryGameBannerCarousel,
  DefaultBackButton,
  PngIcon,
  SvgIcon,
} from '../../../Molecules';

import 'swiper/css';
import styles from './CreateMemoryGameSelectTypeTemplate.module.css';

interface CreateMemoryGameSelectTypeTemplateProps {
  webBoosterType: WebBoosterType | undefined;
  profile: Profile | null | undefined;
  token: number;
  creationStamina: number;
  onClickType: (type: QuickCreateGameMode) => void;
  onClickCurrency: (currencyType: CurrencyType) => void;
}

export const CreateMemoryGameSelectTypeTemplate = (
  props: CreateMemoryGameSelectTypeTemplateProps,
) => {
  const {
    webBoosterType,
    profile,
    token,
    creationStamina,
    onClickType,
    onClickCurrency,
  } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.createMemoryGameSelectTypeTemplate}>
      <div style={{ margin: '12px auto 12px 0.5rem' }}>
        <DefaultBackButton />
      </div>
      {/* 
      <AppBar /> */}

      <CreateMemoryGameBannerCarousel webBoosterType={webBoosterType} />
      <div className={styles.container}>
        <div className={styles.infoSection}>
          <div className={styles.icon}>
            <SvgIcon
              name={SVGIconType.PracticeTick}
              width={80}
              height={80}
              color={'black'}
            />
          </div>

          <p className={styles.title}>
            {t(getWebBoosterVairant(webBoosterType).practiceName)}
          </p>
          <p className={styles.description}>
            {t(getWebBoosterVairant(webBoosterType).neverForgetText)}
          </p>

          {profile && (
            <div className={styles.assetArea}>
              <div className={styles.avatarContainer}>
                <AvatarNode profile={profile} size={50} />
              </div>
              <div className={styles.creationContainer}>
                <div
                  className={styles.creationQuotaBar}
                  onClick={() => {
                    onClickCurrency(StaminaType.CreationStamina);
                  }}
                >
                  <PngIcon name={'CreationStamina'} width={24} height={24} />
                  <p style={{ fontWeight: 'bold' }}>
                    {numbro(creationStamina).format({
                      thousandSeparated: true,
                    })}
                  </p>
                </div>
                <div
                  className={styles.creationQuotaBar}
                  onClick={() => {
                    onClickCurrency(BalanceType.Token);
                  }}
                >
                  <PngIcon name={'Token'} width={24} height={24} />
                  <p style={{ fontWeight: 'bold' }}>
                    {numbro(token).format({ thousandSeparated: true })}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* <div className={styles.helpGuideContainer}>
            <p className={styles.helpGuideMessage}>
              {t(
                'Heed help? View guidelines to learn how to create your own Memory Practice!',
              )}
            </p>
            <button className={styles.guideButton} onClick={onGuideClick}>
              {t('View Guide')}
            </button>
          </div> */}
        </div>
        <div className={styles.gameOptions}>
          {Object.entries(getQuickCreateGameModeVersion(webBoosterType)).map(
            ([key, value]) => {
              if (value.isAvailable) {
                return (
                  <motion.button
                    key={key}
                    className={styles.optionButton}
                    style={{ border: `${value.color} 2px solid` }}
                    onClick={() => {
                      onClickType(key as QuickCreateGameMode);
                    }}
                    whileHover={{
                      color: '#ffffff',
                      backgroundColor: value.color,
                      // stroke: '#ffffff',
                    }}
                    whileTap={{
                      color: '#ffffff',
                      backgroundColor: value.color,
                      // stroke: '#ffffff',
                    }}
                  >
                    <SvgIcon name={value.icon} width={28} height={28} />
                    <span className={styles.typeText}>{t(value.name)}</span>
                    <SvgIcon name={SVGIconType.Arrow} height={20} width={20} />
                  </motion.button>
                );
              }
              return null;
            },
          )}
        </div>

        {/* <div className={styles.creationContainer}>
          <div
            className={styles.creationQuotaBar}
            onClick={() => {
              onClickCurrency(BalanceType.Token);
            }}
          >
            <PngIcon name={'Token'} width={24} height={24} />
            <p>
              {t('Creation Token (Permanent Use): ')}
              {numbro(token).format({ thousandSeparated: true })}
            </p>
          </div>
          <div
            className={styles.creationQuotaBar}
            onClick={() => {
              onClickCurrency(StaminaType.CreationStamina);
            }}
          >
            <PngIcon name={'CreationStamina'} width={24} height={24} />
            <p>
              {t('Creation Stamina (Daily Use): ')}
              {numbro(creationStamina).format({ thousandSeparated: true })}
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};
